import type { AgentInstance } from "./api.ts";

/** Human-friendly relative time like "just now" / "3 min ago" / "5 h ago" / "2 d ago". */
export function relTime(ts: number): string {
	const diff = Date.now() - ts;
	if (diff < 60_000) return "just now";
	if (diff < 60 * 60_000) return `${Math.floor(diff / 60_000)} min ago`;
	if (diff < 24 * 60 * 60_000) return `${Math.floor(diff / (60 * 60_000))} h ago`;
	return `${Math.floor(diff / (24 * 60 * 60_000))} d ago`;
}

/**
 * Pick the most informative inline detail for an agent instance:
 *   ▸ <task title>          — actively processing
 *   ⚠ <error msg> (5m ago)  — recent loop error
 *   idle 7m ago             — online but no recent claim
 *   <relTime(lastSeen)>     — offline (showing how stale the host is)
 *   ""                      — online, no telemetry yet (just started)
 */
export function formatHostDetail(instance: AgentInstance): string {
	if (instance.online && instance.currentTask) {
		return `▸ ${instance.currentTask.title.slice(0, 60)}`;
	}
	if (instance.online && instance.lastError) {
		return `⚠ ${instance.lastError.message.slice(0, 70)} (${relTime(instance.lastError.ts)})`;
	}
	if (instance.online && instance.lastClaimAt) {
		return `idle ${relTime(instance.lastClaimAt)}`;
	}
	if (!instance.online) {
		return relTime(instance.lastSeen);
	}
	return "";
}
